import { Component, Inject, OnInit } from '@angular/core';
import {
  MatDialog,
  MatDialogRef,
  MAT_DIALOG_DATA,
} from '@angular/material/dialog';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';

export interface DialogData {
  icon: string;
  textIcon: string;
  img: string;
  descriptionImg: string;
}

@Component({
  selector: 'app-modal-id-document',
  templateUrl: './modal-id-document.component.html',
  styleUrls: ['./modal-id-document.component.scss'],
})
export class ModalIdDocumentComponent implements OnInit {
  public isImg = true;
  public pdf?: SafeResourceUrl;
  constructor(
    public dialog: MatDialog,
    public dialogRef: MatDialogRef<ModalIdDocumentComponent>,
    public sanitizer: DomSanitizer,
    @Inject(MAT_DIALOG_DATA) public data: DialogData
  ) {}

  ngOnInit(): void {
    this.isImg = this.data.img.match(/image/gi) !== null;
    this.pdf = this.sanitizer.bypassSecurityTrustResourceUrl(this.data.img);
  }

  closeModal(): void {
    this.dialogRef.close();
  }
}
